import { createDraftContext } from './Draft'

export const RequestDraft = createDraftContext()
